
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<BaseRadioButton>({
    model: {
        prop: 'checked',
        event: 'change',
    },
})
export default class BaseRadioButton extends Vue {
    @Prop({ type: String, required: true }) public readonly label!: string
    @Prop({ type: String, required: true }) public readonly value!: string
    @Prop({ type: String, required: false, default: false })
    public readonly checked!: string
    @Prop({ type: String, required: true }) public readonly id!: string
    @Prop({ type: Boolean, required: false }) public readonly disabled!: boolean
    @Prop({ type: String, required: false, default: '' })
    public readonly note!: string

    public get isChecked() {
        return this.value === this.checked
    }

    public handleClick() {
        this.$emit('click', this.value)
    }

    public handleChange() {
        if (!this.disabled) {
            this.$emit('change', this.value)
        }
    }
}
